export default __webpack_public_path__ + "static/media/instagram.7b773d98.png";